"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Clever = _interopRequireDefault(require("./Clever"));
var _OneRoster = _interopRequireDefault(require("./OneRoster"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var componentMapper = {
  clever: _Clever["default"],
  oneroster: _OneRoster["default"]
};

/*
 * Example for this renderer:
 *   One of the objects in the array at location window.cccisd.appDefs.pawn.fields:
 *   {
 *        "handle": "rosterMethod",
 *        "label": "Roster Method",
 *        "data_type": "enum",
 *        "values": [
 *           {
 *               "name": "Manual",
 *               "value": "manual"
 *           },
 *           {
 *               "name": "Clever",
 *               "value": "clever"
 *           },
 *           {
 *               "name": "One Roster",
 *               "value": "oneRoster"
 *           }
 *       ]
 *   }
 *
 * In the column definition:
 *   "handle": "rosterMethod",
 *   "label": "Roster Method",
 *   "name": "rosterMethod",
 *   "filter": true,
 *   "sort": true,
 *   "filterSettings": {
 *      "type": "selectbox"
 *   },
 *   "renderAs": {
 *       "type": "AutoRoster",
 *       "class": "html",
 *       "settings": {
 *           "appdefsEnum": [
 *               {
 *                   "path": "pawn.fields",
 *                   "arrayKey": "handle",
 *                   "arrayValueAtKey": "rosterMethod"
 *               },
 *               {
 *                   "path": "values"
 *               }
 *           ],
 *       }
 *   }
 *
 * Ideally, a database migration will require that all groups have 'manual' saved in the DB
 * if no roster method is specified. However, if you want to include NULL or empty string,
 * you can hack-up the GraphQL Query so filtering works...
 *   rosterMethodRemoveNull: eval(ifNull: { field: "fields.rosterMethod", return: "manual" })
 *   rosterMethod: eval(
 *       if: {
 *           expr1: { field: "rosterMethodRemoveNull" }
 *           expr2: { string: "" }
 *           whenTrue: "manual"
 *           whenFalseValue: { field: "rosterMethodRemoveNull" }
 *       }
 *   )
 */

var AutoRoster = function AutoRoster(settings) {
  return function (props) {
    var value = props.value;
    if (!value || value.toLowerCase() === 'manual') {
      return null;
    }
    var Component = componentMapper[value.toLowerCase()];
    return Component ? /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, settings)) : value;
  };
};
var _default = exports["default"] = AutoRoster;